var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-shopping-cart_svg__clip0_956_11709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.16 6.76a1 1 0 00-1-1.26H6.05a.26.26 0 01-.25-.2l-.57-2.72A3.26 3.26 0 002.05 0a1.25 1.25 0 100 2.5.75.75 0 01.73.59l3.17 15.08a3.25 3.25 0 001.24 1.93.26.26 0 01.1.19.25.25 0 01-.09.2A2 2 0 1010.5 22a2 2 0 00-.21-.89.23.23 0 010-.24.25.25 0 01.21-.12h6a.25.25 0 01.22.12.25.25 0 010 .24 1.91 1.91 0 00-.22.89 2 2 0 004 0 2 2 0 00-.22-.9.29.29 0 010-.24.25.25 0 01.21-.11 1.25 1.25 0 000-2.5H9.13a.75.75 0 01-.73-.59l-.18-.86a.23.23 0 010-.21.25.25 0 01.28-.09h10.72a3 3 0 002.89-2.21l2.05-7.53z",
    fill: "#002147"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-shopping-cart_svg__clip0_956_11709"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconShoppingCart;